if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        preloadImages: false,
        watchSlidesProgress: true,
        autoplay: this.autoplay
          ? {
            delay: this.autoplaySpeed * 1000,
            disableOnInteraction: false,
          }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
            nextEl: this.querySelector(".m-slider-controls__button-next"),
            prevEl: this.querySelector(".m-slider-controls__button-prev"),
          }
          : false,
        pagination: this.showDots
          ? {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            bulletClass: "m-dot",
            bulletActiveClass: "m-dot--active",
          }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();
      this.initVideoObserver();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    initVideoObserver() {
      if (!("IntersectionObserver" in window)) return;
      const videos = this.querySelectorAll("video");
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach(({ isIntersecting, target: v }) => {
            if (isIntersecting) {
              if (v.preload !== "auto") v.preload = "auto";

              // Resume if it's the active slide
              const activeSlide = this.slider && this.slider.slides[this.slider.activeIndex];
              if (activeSlide && activeSlide.contains(v)) {
                v.play().catch(() => { });
              }
            } else {
              if (!v.paused) {
                try {
                  v.pause();
                } catch (e) { }
              }
            }
          });
        },
        { root: null, threshold: 0.25 }
      );
      videos.forEach((v) => {
        v.preload = "none";
        io.observe(v);
      });
      this._videoIO = io;
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const activeSlide = slides[activeIndex];
      if (!activeSlide) return;

      const slideType = activeSlide.dataset.slideType;
      const customDuration = parseInt(activeSlide.dataset.rotationDuration);

      // Handle Autoplay Speed Override
      if (this.autoplay && swiper.autoplay) {
        let newDelay = this.autoplaySpeed * 1000;
        if (customDuration && customDuration !== -1) {
          newDelay = customDuration * 1000;
        }

        if (swiper.params.autoplay.delay !== newDelay) {
          swiper.params.autoplay.delay = newDelay;
        }

        swiper.autoplay.stop();
        swiper.autoplay.run(); // Use run() to ensure it starts even if it was stopped by interaction
        swiper.autoplay.start();
      }

      // Pause all videos in other slides
      this.querySelectorAll("video").forEach((video) => {
        if (!activeSlide.contains(video)) {
          video.pause();
        }
      });

      if (slideType === "video_slide") {
        const videos = activeSlide.querySelectorAll("video");
        videos.forEach((video) => {
          if (video.preload !== "auto") video.preload = "auto";

          // Restart video from beginning
          video.currentTime = 0;
          video.play().catch(() => { });
        });
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
